import {Game} from "@game/game";
import {AuthenticateDialog} from "@components/authentication/AuthenticateDialog";
import {SelectNicknameDialog} from "@components/authentication/SelectNicknameDialog";
import {GameDialog} from "@components/dialog/GameDialog";
import {ScoreDialog} from "@components/dialog/ScoreDialog";
import {DefinitionDialog} from "@components/dialog/DefinitionDialog";
import React from "react";
import {RemoveAdverts} from "@components/dialog/RemoveAdverts";
import {TutorialDialog} from "@components/dialog/TutorialDialog";
import {BorderProposalDialog} from "@components/dialog/BorderProposalDialog";
import {LeagueDialog} from "@components/dialog/LeagueDialog";
import {CompetitionInviteDialog} from "@components/dialog/CompetitionInviteDialog";
import {Vector2} from "@utility/vector2";

interface IDialogs {
    game: Game
    onNavigate: (pos: Vector2) => void
}
export function Dialogs({game, onNavigate}: IDialogs) {
    return (
        <div>
            <AuthenticateDialog game={game}/>
            <SelectNicknameDialog game={game}/>
            <GameDialog game={game}/>
            <ScoreDialog game={game}/>
            <DefinitionDialog onNavigate={onNavigate}/>
            <RemoveAdverts game={game}/>
            <TutorialDialog/>
            <BorderProposalDialog/>
            <LeagueDialog game={game}/>
            <CompetitionInviteDialog game={game}/>
        </div>
    );
}